/* eslint-disable max-len */
import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

import { useColors } from '@hooks';
import { ColorType } from '@types';

/**
 * Interface for ApplePaySvg and GooglePaySvg components
 */
export interface IPaymentMethodSvgProps extends SvgProps {
  contentColor?: ColorType;
}

export function ApplePaySvg({
  contentColor = '$background0',
  ...props
}: IPaymentMethodSvgProps) {
  const colors = useColors();

  return (
    <Svg width={55} height={22} fill="none" {...props}>
      <Path
        d="M10.748 4.327c-1.337 0-2.415.809-3.111.809-.73 0-1.707-.764-2.864-.764-2.2 0-4.436 1.83-4.436 5.256 0 2.145.831 4.402 1.853 5.873.865 1.225 1.64 2.235 2.74 2.235 1.09 0 1.573-.718 2.932-.718 1.37 0 1.684.696 2.886.696 1.202 0 1.999-1.09 2.751-2.168.831-1.246 1.19-2.46 1.202-2.515-.067-.023-2.358-.955-2.358-3.583 0-2.268 1.796-3.28 1.898-3.358-1.18-1.718-2.988-1.763-3.493-1.763Zm-.618-1.449c.54-.662.921-1.56.921-2.47 0-.124-.011-.247-.034-.348-.876.033-1.954.584-2.594 1.336-.494.573-.966 1.482-.966 2.392 0 .135.023.28.034.326.056.011.146.022.236.022.797 0 1.808-.539 2.403-1.258Zm8.986-1.55v16.206h2.897v-5.312h3.515c3.28 0 5.57-2.201 5.57-5.413 0-3.268-2.212-5.48-5.446-5.48h-6.537Zm2.897 2.426h2.875c2.089 0 3.268 1.067 3.268 3.055 0 1.932-1.213 3.01-3.28 3.01h-2.863V3.754Zm14.522 11.792c-1.235 0-2.123-.617-2.123-1.65 0-1 .73-1.562 2.291-1.663l2.774-.18v.978c0 1.426-1.258 2.515-2.942 2.515Zm-.82 2.19c1.606 0 2.954-.696 3.639-1.886h.19v1.684h2.685V9.145c0-2.605-1.775-4.144-4.93-4.144-2.92 0-4.953 1.381-5.178 3.549h2.628c.258-.831 1.134-1.28 2.415-1.28 1.505 0 2.313.673 2.313 1.875v1.033l-3.167.191c-2.987.18-4.66 1.46-4.66 3.684 0 2.246 1.695 3.683 4.065 3.683Zm9.614 4.257c2.752 0 4.066-1.011 5.11-4.066l4.436-12.679h-2.942l-2.864 9.59h-.19l-2.876-9.59h-3.055L47.34 17.59l-.147.54c-.359 1.134-1.021 1.583-2.2 1.583-.192 0-.607-.011-.764-.045v2.28c.18.033.932.045 1.1.045Z"
        fill={colors[contentColor]}
      />
    </Svg>
  );
}
